export class AutomateTransferModel {
    constructor() { }
    FromPhoneNumber: string;
    ToPhoneNumbers: string[];
    Threshold: number;
    Type: number;
    Transfer: number;
    Id: string;
}

export enum AutomateTransferCreditType {
    BOTH = 0,
    ADDON_CREDITS_NORMAL,
    ADDON_CREDITS_GROUP,
}

export const mapToAutomateTransferLogs = (x: any): AutomateTransferModel => {
    return {
        FromPhoneNumber: x.fromPhoneNumber,
        ToPhoneNumbers: [x.toPhoneNumbers],
        Threshold: x.threshold,
        Type: x.type,
        Transfer: x.transfer,
        Id: x.id,
    } as AutomateTransferModel;
}
